import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

export default function ProgramacaoTeares({
    artigosOcultos,
    filteredArtigos,
    onToggleProgramacaoCompleta,
    onToggleArtigo,
    onToggleTurma,
    onPrint,
    printing,
    programacaoPorArtigoData,
    progRef,
    totaisPorArtigo,
    turmasOcultas,
    values,
    visualizacaoCompleta,
}) {
    return (
        <div style={{
            backgroundColor: '#fff',
            border: '1px solid #dfe4ea',
            borderRadius: 6,
            marginBottom: 16,
            overflow: 'hidden',
        }}>
            <div style={{
                backgroundColor: '#f8f9fa',
                borderBottom: '1px solid #dfe4ea',
                padding: '12px 16px',
            }}>
                <div className="p-d-flex p-flex-wrap p-jc-between p-ai-start" style={{ gap: 12 }}>
                    <div>
                        <div style={{ color: '#263238', fontSize: 18, fontWeight: 700 }}>
                            Programação dos teares
                        </div>
                        <div style={{ color: '#607d8b', fontSize: 13, marginTop: 2 }}>
                            {visualizacaoCompleta
                                ? 'Programação completa dos rolos'
                                : 'Apenas rolos em execução no tear'}
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-wrap p-ai-center" style={{ gap: 16 }}>
                        <label className="p-d-flex p-ai-center" style={{ cursor: 'pointer', gap: 6 }}>
                            <input
                                checked={visualizacaoCompleta}
                                onChange={(event) => onToggleProgramacaoCompleta(event.target.checked)}
                                type="checkbox"
                            />
                            Ver programação completa
                        </label>
                        {values.turmas?.map((item) => (
                            <div className="p-d-flex p-ai-center" key={`turma${item.id}`}>
                                <button
                                    aria-label={`Filtrar turma ${item.nome}`}
                                    onClick={() => onToggleTurma(item.nome)}
                                    style={{
                                        backgroundColor: turmasOcultas.includes(item.nome) ? '#8395a7' : item.hex,
                                        border: 'none',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                        height: 28,
                                        width: 28,
                                    }}
                                />
                                <span style={{
                                    color: turmasOcultas.includes(item.nome) ? '#8395a7' : '#263238',
                                    fontSize: 13,
                                    fontWeight: 600,
                                    marginLeft: 6,
                                    textDecoration: turmasOcultas.includes(item.nome) ? 'line-through' : 'none',
                                }}>
                                    Turma {item.nome}
                                </span>
                            </div>
                        ))}
                        <Button
                            className="p-button-sm p-button-secondary"
                            icon="pi pi-print"
                            label="Imprimir"
                            onClick={onPrint}
                        />
                    </div>
                </div>

                <div className="p-d-flex p-flex-wrap" style={{ gap: 6, marginTop: 12 }}>
                    {values.artigos.map((artigo, index) => (
                        <Button
                            className={'p-button-sm p-button-secondary ' + (artigosOcultos.includes(artigo) ? 'p-button-danger' : '')}
                            key={index}
                            onClick={() => onToggleArtigo(artigo)}
                        >
                            {artigo}
                        </Button>
                    ))}
                </div>
            </div>

            <DataTable
                id="my-table"
                ref={progRef}
                responsiveLayout={printing ? "" : "scroll"}
                size="small"
                tableStyle={{ borderCollapse: 'separate', borderSpacing: 0 }}
                value={filteredArtigos}
            >
                <Column
                    header="Artigo"
                    headerStyle={{ backgroundColor: '#eef2f5', minWidth: 110, whiteSpace: 'nowrap' }}
                    bodyStyle={{
                        backgroundColor: '#f8f9fa',
                        borderColor: '#dfe4ea',
                        fontSize: 17,
                        fontWeight: 700,
                        minWidth: 110,
                    }}
                    body={(rowData) => rowData}
                />
                {values.datas.map((item, index) => (
                    <Column
                        key={'column' + index}
                        header={item}
                        headerStyle={{
                            backgroundColor: '#eef2f5',
                            fontSize: 15,
                            minWidth: 120,
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                        }}
                        bodyStyle={{
                            borderColor: '#dfe4ea',
                            minWidth: 120,
                            padding: 6,
                        }}
                        body={(rowData) => {
                            const teares = programacaoPorArtigoData[`${rowData}|${item}`] || [];

                            return (
                                <div key={'div' + index} className="p-d-flex p-flex-wrap p-jc-center" style={{ gap: 4 }}>
                                    {teares.filter((element) => !turmasOcultas.includes(element.turma)).map((element) => (
                                        <div key={'tear' + element.tear} className="tear-box" style={{
                                            backgroundColor: element.cor,
                                            border: '1px solid rgba(0, 0, 0, 0.16)',
                                            borderRadius: 4,
                                            color: '#1f2933',
                                            fontWeight: 700,
                                            minWidth: 32,
                                            padding: '5px 7px',
                                            textAlign: 'center',
                                        }}>
                                            {element.tear}
                                        </div>
                                    ))}
                                </div>
                            );
                        }}
                    />
                ))}
                <Column
                    header="Total"
                    headerStyle={{ backgroundColor: '#eef2f5', minWidth: 70, textAlign: 'center' }}
                    bodyStyle={{ borderColor: '#dfe4ea', fontWeight: 700, textAlign: 'center' }}
                    body={(rowData) => <span style={{ fontSize: 17 }}>{totaisPorArtigo[rowData] || 0}</span>}
                />
            </DataTable>
        </div>
    );
}
